import React from "react";

const TitleComponent = (props)=>{
    return (
        <h2 className="mb-6 font-bold text-xl text-black leading-tight font-roboto-regular">{props.title}</h2>
    )
}

export default TitleComponent;